import topairs from 'lodash.topairs'

Object.entries = Object.entries || topairs
